import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonDataService } from './../../common-data.service';
import { TarefasService } from './../../api/services/tarefas.service';
import { DepartamentosService } from './../../api/services/departamentos.service';
import { ModalService } from '../../shared/_services/index';
import { ToastsService } from './../../api/toasts/toasts.service';
declare var swal: any;


@Component({
	selector: 'app-tarefas',
	templateUrl: './tarefas.component.html',
	styleUrls: ['./tarefas.component.scss']
})
export class TarefasComponent implements OnInit {
	isFormLoading: boolean = false;
	tableSettings: any = {
		columns: [
			// { 
			// 	name: 'Código',
			// 	prop: 'codTarefa'
			// },
			{
				name: 'Nome',
				prop: 'nome'
			},
			{
				name: 'Descrição',
				prop: 'descricao'
			},
			{
				name: 'Ambiente de execução',
				prop: 'ambienteExecucao'
			},
			{
				name: 'Tempo de execução',
				prop: 'tempoExecucao'
			}
		],
		temp: [],
		reorderable: true,
		filterrows: [],
		isLoading: true
	}

	pageTitle: any = {
		title: 'Tarefas',
		breadcumbs: [
			{
				title: 'Dashboard',
				href: '/'
			}
		],
		breadcumbActive: 'Tarefas'
	}

	form: FormGroup;
	selected: any = {};
	isCreate: boolean = false;
	departamentos: any[] = []

	constructor(private _commondata: CommonDataService,
		private service: TarefasService,
		private departamentosService: DepartamentosService,
		private modalService: ModalService,
		private fb: FormBuilder,
		private toastsService: ToastsService) {
		this.form = this.fb.group({
			nome: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
			descricao: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
			tempoExecucao: new FormControl('', [Validators.required]),
			ambienteExecucao: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(2000)]),
			codDepartamento: new FormControl('', [Validators.required]),
		});
	}

	ngOnInit() {
		this.load();
	}

	load() {
		this.service.get().subscribe((data: any[]) => {
			this.tableSettings.temp = data;
			this.tableSettings.filterrows = data;
			this.tableSettings.isLoading = false;
			this.isFormLoading = false;
		});

		this.departamentosService.get().subscribe((data: any[]) => {
			this.departamentos = data;
		});
	}

	addNew() {
		this.isCreate = true;
		this.form.reset();
		this.selected = {}
		this.modalService.open('modal');
	}

	onSelect(item) {
		this.isCreate = false;
		this.selected = item;
		this.form.reset();
		this.form.patchValue(item);
		this.modalService.open('modal');
	}

	onReload() {
		this.tableSettings.isLoading = true;
		this.load();
	}

	updateFilter(val) {
		const temp = this.tableSettings.temp.filter(function (d) {
			return (d.nome.toLowerCase().indexOf(val) !== -1 ||
				d.descricao.toLowerCase().indexOf(val) !== -1 ||
				String(d.codTarefa).indexOf(val) !== -1)
				|| !val;
		});

		this.tableSettings.filterrows = temp;
	}

	closeModal(id: string) {
		this.modalService.close(id);
	}

	insereValorNaString(str, item, every) {
		for (let i = 0; i < str.length; i++) {
			if (!(i % (every + 1))) {
				str = str.substring(0, i) + item + str.substring(i);
			}
		}
		return str.substring(1);
	}

	submit() {
		if (this.form.valid) {
			this.isFormLoading = true;
			if (this.isCreate) {
				var data = this.form.value
				this.service.post(data).subscribe((data: any) => {
					this.closeModal('modal');
					this.toastsService.toastSuccess("Salvo com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					if (typeof error.error === 'string') {
						this.toastsService.toastError(error.error);
					}
					else if (error.error.errors) {
						let errorMessage = ""
						Object.getOwnPropertyNames(error.error.errors).forEach((field) => {
							errorMessage += error.error.errors[field]
						})

						this.toastsService.toastError(errorMessage);
					}
					else {
						this.toastsService.toastError("Revise todos os dados e tente novamente!");
					}
				});
			}
			else {
				this.service.patch(this.form.value, this.selected.codTarefa).subscribe(() => {
					this.closeModal('modal');
					this.toastsService.toastSuccess("Editado com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					this.toastsService.toastError("Revise todos os dados e tente novamente!");
				});
			}

		}
		else {
			this.validateAllFormFields(this.form);
		}
	}

	remove() {
		swal({
			text: 'Deseja realmente deletar essa tarefa?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			cancelButtonText: 'Não!',
			confirmButtonText: 'Sim, deletar!'
		}).then((result) => {
			if (result.value) {
				this.isFormLoading = true;
				this.service.delete(this.selected.codTarefa).subscribe(() => {
					this.closeModal('modal');
					this.toastsService.toastSuccess("Deletado com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					this.toastsService.toastError("Tente novamente!");
				});
			}
		});
	}

	campoValido(nomeCampo) {
		return !this.form.get(nomeCampo).valid && (this.form.get(nomeCampo).dirty || this.form.get(nomeCampo).touched)
	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateAllFormFields(control);
			}
		});
	}
}
